import { render, staticRenderFns } from "./triaged.vue?vue&type=template&id=c0c7b1ba&scoped=true"
import script from "./triaged.vue?vue&type=script&lang=js"
export * from "./triaged.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c7b1ba",
  null
  
)

export default component.exports